angular.module('picmonicng').directive('pathwaysBlock', [
  function () {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/templates/directives/pathways-blocks.html',
      scope: false,
      controller: [
        '$scope',
        '$state',
        '$stateParams',
        'Pathways',
        'MarketOptionsConfig',
        'UserService',
        '$rootScope',
        'BrowseService',
        '$location',
        '$cookies',
        '$modal',
        'ngBowser',
        function (
          $scope,
          $state,
          $stateParams,
          Pathways,
          MarketOptionsConfig,
          UserService,
          $rootScope,
          BrowseService,
          $location,
          $cookies,
          $modal,
          ngBowser
        ) {
          $scope.onPathways = false;
          $scope.onResources = false;
          $scope.filterSections = false;

          if ($state.current.name === 'app.resources.tab') {
            $scope.onResources = true;
          }

          if ($state.current.name === 'app.pathways.market' || $scope.onResources) {
            $scope.onPathways = true;
          }

          if (
            $state.current.name === 'app.pathways.market.boards' ||
            $state.current.name === 'app.pathways.market.books' ||
            $state.current.name === 'app.pathways.market.courses' ||
            $state.current.name === 'app.pathways.market.first-aid'
          ) {
            $scope.onPathways = true;
            $scope.filterSections = true;
          }

          $scope.sections = [];
          $scope.UserService = UserService;

          $scope.requestBook = function () {
            window.open(UserService.generateTypeFormURL('RjPxo7'), '_blank');
          };

          $scope.selectPathwaysBlock = function (section) {
            if ($scope.onPathways) {
              section.open = !section.open;
            } else {
              $scope.toggleContent(section.pathway_type + '_' + section.curriculum, section.name);
            }
          };

          $scope.marketSort = function (pathway) {
            return MarketOptionsConfig.getMarketById(pathway.market_id).order;
          };

          var market_id = $scope.market ? $scope.market.id : null;

          $scope.hideOnboarding = function () {
            $scope.show_onboarding = false;
            UserService.see('course_manager_onboard');
          };
          $scope.sections = {};
          angular.forEach(UserService.user.pathway_sections, function (section) {
            $scope.sections[section.name] = section;
          });

          $scope.getPathwaySections = function () {
            $scope.total = 0;
            $scope.total_mastered = 0;
            $scope.dataChanged = false;
            $scope.pathwaysLoading = true;
            var sections = Pathways.getv3({ market_id: market_id });
            sections.$promise.finally(function () {
              $scope.sections = sections;
              $scope.pathwaysLoading = false;
              $scope.multipleMarkets = false;
              var lastMarketId = 0;

              var resourcesOnMarketSlug = false;
              if ($scope.onResources) {
                resourcesOnMarketSlug = MarketOptionsConfig.getMarketBySlug($stateParams.tab);
              }

              angular.forEach($scope.sections, function (section) {
                if ($scope.onPathways) {
                  section.open = true;
                }

                if ($scope.onResources && !resourcesOnMarketSlug) {
                  if (
                    section.pathway_type !== 'boards' &&
                    section.pathway_type !== 'first-aid' &&
                    section.pathway_type !== 'books'
                  ) {
                    section.open = false;
                  }

                  if (section.curriculum === 'usmle-step-2') {
                    section.open = false;
                  }
                }

                angular.forEach(section.pathways, function (pathway) {
                  $scope.total += parseInt(pathway.total);
                  $scope.total_mastered += parseInt(pathway.total_mastered);

                  if (!$scope.multipleMarkets && lastMarketId && lastMarketId !== pathway.market_id) {
                    $scope.multipleMarkets = true;
                  }
                  lastMarketId = pathway.market_id;
                });
              });

              if ($scope.filterSections) {
                for (section in $scope.sections) {
                  if ($scope.sections.hasOwnProperty(section) && section.indexOf('$') !== 0) {
                    if (
                      $scope.sections[section].pathway_type !== $stateParams.pathway_type ||
                      $scope.sections[section].curriculum !== $stateParams.curriculum
                    ) {
                      delete $scope.sections[section];
                    }
                  }
                }
              }

              if (
                UserService.user.has_seen &&
                !UserService.user.has_seen.course_manager_onboard &&
                UserService.user.cards_viewed >= 10 &&
                !UserService.user.is_trial &&
                ngBowser.isDesktop()
              ) {
                $scope.show_onboarding = true;
              }
            });
          };
          if (window.pathwayMarketId === market_id && !UserService.user.user_id) {
            $scope.sections = window.pathwayMarket;
            angular.forEach($scope.sections, function (section) {
              if ($scope.onPathways) {
                section.open = true;
              }

              angular.forEach(section.pathways, function (pathway) {
                $scope.total += parseInt(pathway.total);
                $scope.total_mastered += parseInt(pathway.total_mastered);
              });
            });
          } else {
            $scope.getPathwaySections();
          }

          // Listen for data change event
          var updateIfVisible = function () {
            if (BrowseService.browseOpen && !BrowseService.secondaryVisible && $scope.dataChanged) {
              $scope.getPathwaySections();
            }
          };
          var onChange = function () {
            $scope.dataChanged = true;
            updateIfVisible();
          };
          $scope.$on('pathwayDataChanged', onChange);
          $scope.$on('cardDataChanged', onChange);
          $scope.$on('browseVisibilityChange', updateIfVisible);
        },
      ],
    };
  },
]);
